import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Protocol17025ChartFile_Interface } from 'src/app/Interface/Protocol17025/Protocol17025ChartFile_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Protocol17025ChartFileService {


  constructor(private http: HttpClient) { }

  GetRecord(Token:String,id:Number):Observable<Array<Protocol17025ChartFile_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025ChartFile?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<Protocol17025ChartFile_Interface>
      })
    )
  }

  GetSingle(Token:String,id:Number):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025ChartFile/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as any
      })
    )
  }



  GetView(Token: String,
    keyword: String,
    startDate: String,
    endDate: String,
    SubmitPeriodDate: String,
    id: Number,
    view: Number,
    tag_id: Array<Number>):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      keyword:keyword,
      id:id,
      view:view,
      tag_id:tag_id,
      Token:Token,
      startDate:startDate,
      endDate:endDate,
      SubmitPeriodDate:SubmitPeriodDate,
    }


    return this.http.post(environment.BaseUrl + "Daro/Protocol17025ChartFile/GetView",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }

  uploadPdf(body,Token:String,id:number){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Protocol17025ChartFile/Upload?token="+Token+"&id="+id,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  AddEdit(model: Protocol17025ChartFile_Interface,tag_id:Array<number>,Token:String):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      dsc:model.dsc,
      title:model.title,
      chart_id:model.chart_id,
      src:model.src,
      tag_id:tag_id,
      token:Token
    }


    return this.http.post(environment.BaseUrl + "Daro/Protocol17025ChartFile/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }

  Delete(id: number, Token: String): Observable<Protocol17025ChartFile_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Protocol17025ChartFile/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Protocol17025ChartFile_Interface
      })
    )

  }

}
